import { memo, useCallback } from 'react';
import { Modal, Text, Button, Stack } from '@mantine/core';
import { IconClockExclamation } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useGeoMarkupStore } from '@/store';
import { selectSessionExpired } from '@/store/selectors/authSelectors';
import { buildAuthorizeUrl } from '@/utils/authRedirect';
import {
  Z_INDEX_MODAL_CRITICAL,
  Z_INDEX_MODAL_CRITICAL_BACKDROP,
} from '@/constants/zIndex';
import styles from './SessionExpiredModal.module.css';

const ICON_SIZE = 48;

export const SessionExpiredModal = memo(function SessionExpiredModal() {
  const { t } = useTranslation();
  const sessionExpired = useGeoMarkupStore(selectSessionExpired);

  const handleLogin = useCallback(() => {
    window.location.href = buildAuthorizeUrl(
      window.location.pathname + window.location.search
    );
  }, []);

  return (
    <Modal
      opened={sessionExpired}
      onClose={() => {}}
      withCloseButton={false}
      closeOnClickOutside={false}
      closeOnEscape={false}
      centered
      size="sm"
      title={t('session.expired.title')}
      zIndex={Z_INDEX_MODAL_CRITICAL}
      styles={{
        overlay: {
          zIndex: Z_INDEX_MODAL_CRITICAL_BACKDROP,
        },
      }}
    >
      <Stack align="center" gap="md" className={styles.content}>
        <IconClockExclamation size={ICON_SIZE} className={styles.icon} />
        <Text size="sm">{t('session.expired.message')}</Text>
        <Button onClick={handleLogin} fullWidth>
          {t('session.expired.loginButton')}
        </Button>
      </Stack>
    </Modal>
  );
});
